import { put } from "./api";
import { EndpointsName } from "./authTypes";

const USER_IS_ACTIVE_INTERVAL_DURATION = 30000;

const setUserIsActive = () => {
  put(EndpointsName.BBF, `/presence`, null).subscribe({
    error: (err) => console.error("presence-error", err),
  });
};

export const setUserIsActiveInterval = () => {
  setUserIsActive();
  return setInterval(() => {
    setUserIsActive();
  }, USER_IS_ACTIVE_INTERVAL_DURATION);
};
